import { createTestBed } from '@visiba/instantiation';

export const sharedTestBed = createTestBed();
export const sharedResolution = sharedTestBed.resolution;
